import { render, staticRenderFns } from "./FormSection.vue?vue&type=template&id=4cfb8428"
import script from "./FormSection.vue?vue&type=script&lang=js"
export * from "./FormSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports